<form [formRoot]="form()" class="space-y-6">
  <div hlmFieldGroup>
    <fieldset hlmFieldSet>
      <legend hlmFieldLegend>
        {{ 'contacts.form.sections.name' | transloco }}
      </legend>

      <div hlmFieldGroup class="mt-4">
        <div hlmField>
          <label hlmFieldLabel for="title">
            {{ 'contacts.form.fields.title' | transloco }}
          </label>
          <select
            id="title"
            class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-xs"
            [formField]="form().title"
          >
            @for (option of titleOptions; track option.value) {
              <option [value]="option.value">
                {{ option.label | transloco }}
              </option>
            }
          </select>
        </div>

        <div
          hlmField
          [attr.data-invalid]="
            form().firstName().touched() && form().firstName().invalid()
          "
        >
          <label hlmFieldLabel for="firstName">
            {{ 'contacts.form.fields.firstName' | transloco }}
            <span class="text-destructive">*</span>
          </label>
          <input
            id="firstName"
            hlmInput
            type="text"
            class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-xs"
            [formField]="form().firstName"
            [placeholder]="'contacts.form.placeholders.firstName' | transloco"
            [attr.aria-invalid]="
              form().firstName().touched() && form().firstName().invalid()
            "
          />
          @if (form().firstName().touched() && form().firstName().invalid()) {
            @for (error of form().firstName().errors(); track $index) {
              <hlm-field-error [forceShow]="true">{{
                error.message | transloco
              }}</hlm-field-error>
            }
          }
        </div>

        <div
          hlmField
          [attr.data-invalid]="
            form().lastName().touched() && form().lastName().invalid()
          "
        >
          <label hlmFieldLabel for="lastName">
            {{ 'contacts.form.fields.lastName' | transloco }}
            <span class="text-destructive">*</span>
          </label>
          <input
            id="lastName"
            hlmInput
            type="text"
            class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-xs"
            [formField]="form().lastName"
            [placeholder]="'contacts.form.placeholders.lastName' | transloco"
            [attr.aria-invalid]="
              form().lastName().touched() && form().lastName().invalid()
            "
          />
          @if (form().lastName().touched() && form().lastName().invalid()) {
            @for (error of form().lastName().errors(); track $index) {
              <hlm-field-error [forceShow]="true">{{
                error.message | transloco
              }}</hlm-field-error>
            }
          }
        </div>
      </div>
    </fieldset>

    <hlm-field-separator />

    <fieldset hlmFieldSet>
      <legend hlmFieldLegend>
        {{ 'contacts.form.sections.contact' | transloco }}
      </legend>

      <div hlmFieldGroup class="mt-4">
        <div hlmField>
          <label hlmFieldLabel for="type">
            {{ 'contacts.form.fields.type' | transloco }}
            <span class="text-destructive">*</span>
          </label>
          <select
            id="type"
            class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-xs"
            [formField]="form().type"
          >
            @for (option of typeOptions; track option.value) {
              <option [value]="option.value">
                {{ option.label | transloco }}
              </option>
            }
          </select>
        </div>

        <div
          hlmField
          [attr.data-invalid]="
            form().email().touched() && form().email().invalid()
          "
        >
          <label hlmFieldLabel for="email">
            {{ 'contacts.form.fields.email' | transloco }}
            <span class="text-destructive">*</span>
          </label>
          <input
            id="email"
            hlmInput
            type="email"
            class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-xs"
            [formField]="form().email"
            [placeholder]="'contacts.form.placeholders.email' | transloco"
            [attr.aria-invalid]="
              form().email().touched() && form().email().invalid()
            "
          />
          @if (form().email().touched() && form().email().invalid()) {
            @for (error of form().email().errors(); track $index) {
              <hlm-field-error [forceShow]="true">{{
                error.message | transloco
              }}</hlm-field-error>
            }
          }
        </div>

        <div
          hlmField
          [attr.data-invalid]="
            form().additionalEmail().touched() &&
            form().additionalEmail().invalid()
          "
        >
          <label hlmFieldLabel for="additionalEmail">
            {{ 'persons.list.fields.privateEmail' | transloco }}
            <span class="text-muted-foreground text-xs font-normal">
              ({{ 'common.form.optional' | transloco }})
            </span>
          </label>
          <input
            id="additionalEmail"
            hlmInput
            type="email"
            class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-xs"
            [formField]="form().additionalEmail"
            [placeholder]="
              'contacts.form.placeholders.additionalEmail' | transloco
            "
            [attr.aria-invalid]="
              form().additionalEmail().touched() &&
              form().additionalEmail().invalid()
            "
          />
          @if (
            form().additionalEmail().touched() &&
            form().additionalEmail().invalid()
          ) {
            @for (error of form().additionalEmail().errors(); track $index) {
              <hlm-field-error [forceShow]="true">{{
                error.message | transloco
              }}</hlm-field-error>
            }
          }
        </div>

        <div
          hlmField
          [attr.data-invalid]="
            form().phone().touched() && form().phone().invalid()
          "
        >
          <label hlmFieldLabel for="phone">
            {{ 'persons.list.fields.mobile' | transloco }}
            <span class="text-muted-foreground text-xs font-normal">
              ({{ 'common.form.optional' | transloco }})
            </span>
          </label>
          <input
            id="phone"
            hlmInput
            type="tel"
            class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-xs"
            [formField]="form().phone"
            [placeholder]="'contacts.form.placeholders.phone' | transloco"
            [attr.aria-invalid]="
              form().phone().touched() && form().phone().invalid()
            "
          />
          @if (form().phone().touched() && form().phone().invalid()) {
            @for (error of form().phone().errors(); track $index) {
              <hlm-field-error [forceShow]="true">{{
                error.message | transloco
              }}</hlm-field-error>
            }
          }
        </div>

        <div
          hlmField
          [attr.data-invalid]="
            form().privateMobile().touched() && form().privateMobile().invalid()
          "
        >
          <label hlmFieldLabel for="privateMobile">
            {{ 'persons.list.fields.privateMobile' | transloco }}
            <span class="text-muted-foreground text-xs font-normal">
              ({{ 'common.form.optional' | transloco }})
            </span>
          </label>
          <input
            id="privateMobile"
            hlmInput
            type="tel"
            class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-xs"
            [formField]="form().privateMobile"
            [placeholder]="
              'persons.form.placeholders.privateMobile' | transloco
            "
            [attr.aria-invalid]="
              form().privateMobile().touched() && form().privateMobile().invalid()
            "
          />
          @if (
            form().privateMobile().touched() && form().privateMobile().invalid()
          ) {
            @for (error of form().privateMobile().errors(); track $index) {
              <hlm-field-error [forceShow]="true">{{
                error.message | transloco
              }}</hlm-field-error>
            }
          }
        </div>
      </div>
    </fieldset>

    <hlm-field-separator />

    <fieldset hlmFieldSet>
      <legend hlmFieldLegend>
        {{ 'persons.list.details.sections.address' | transloco }}
      </legend>

      <div hlmFieldGroup class="mt-4">
        <div hlmField>
          <label hlmFieldLabel for="street">
            {{ 'persons.list.fields.street' | transloco }}
          </label>
          <input
            id="street"
            hlmInput
            type="text"
            class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-xs"
            [formField]="form().street"
            [placeholder]="'persons.form.placeholders.street' | transloco"
          />
        </div>

        <div hlmField>
          <label hlmFieldLabel for="city">
            {{ 'persons.list.fields.city' | transloco }}
          </label>
          <input
            id="city"
            hlmInput
            type="text"
            class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-xs"
            [formField]="form().city"
            [placeholder]="'persons.form.placeholders.city' | transloco"
          />
        </div>

        <div hlmField>
          <label hlmFieldLabel for="postalCode">
            {{ 'persons.list.fields.postalCode' | transloco }}
          </label>
          <input
            id="postalCode"
            hlmInput
            type="text"
            class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-xs"
            [formField]="form().postalCode"
            [placeholder]="'persons.form.placeholders.postalCode' | transloco"
          />
        </div>

        <div hlmField>
          <label hlmFieldLabel for="country">
            {{ 'persons.list.fields.country' | transloco }}
          </label>
          <input
            id="country"
            hlmInput
            type="text"
            class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-xs"
            [formField]="form().country"
            [placeholder]="'persons.form.placeholders.country' | transloco"
          />
        </div>
      </div>
    </fieldset>

    <hlm-field-separator />

    <fieldset hlmFieldSet>
      <legend hlmFieldLegend>
        {{ 'persons.list.details.sections.administration' | transloco }}
      </legend>

      <div hlmFieldGroup class="mt-4">
        <div hlmField>
          <label hlmFieldLabel for="socialSecurityNumber">
            {{ 'persons.list.fields.socialSecurityNumber' | transloco }}
          </label>
          <input
            id="socialSecurityNumber"
            hlmInput
            type="text"
            class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-xs"
            [formField]="form().socialSecurityNumber"
            [placeholder]="
              'persons.form.placeholders.socialSecurityNumber' | transloco
            "
          />
        </div>


        <div hlmField>
          <label hlmFieldLabel for="personnelNumber">
            {{ 'persons.list.fields.personnelNumber' | transloco }}
          </label>
          <input
            id="personnelNumber"
            hlmInput
            type="text"
            class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-xs"
            [formField]="form().personnelNumber"
            [placeholder]="
              'persons.form.placeholders.personnelNumber' | transloco
            "
          />
        </div>



        <div hlmField>
          <label hlmFieldLabel for="vacationDays">
            {{ 'persons.list.fields.vacationDays' | transloco }}
          </label>
          <input
            id="vacationDays"
            hlmInput
            type="number"
            class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-xs"
            [formField]="form().vacationDays"
            [placeholder]="'persons.form.placeholders.vacationDays' | transloco"
          />
        </div>

      </div>
    </fieldset>

    <!-- <hlm-field-separator /> -->

    <!-- <fieldset hlmFieldSet>
      <legend hlmFieldLegend>
        {{ 'contacts.form.fields.tags' | transloco }}
      </legend>

      <div hlmField class="mt-4">
        <p hlmFieldDescription>
          {{ 'contacts.form.help.tags' | transloco }}
        </p>
        <div class="mt-2 flex flex-wrap gap-2">
          @for (option of tagOptions; track option.value) {
            <button
              type="button"
              class="rounded-full border px-3 py-1 text-xs font-medium transition-colors"
              [class]="
                hasTag(option.value)
                  ? 'border-primary bg-primary/10 text-primary'
                  : 'border-border text-foreground hover:bg-secondary'
              "
              (click)="toggleTag(option.value)"
            >
              {{ option.label | transloco }}
            </button>
          }
        </div>
      </div>
    </fieldset> -->
  </div>
</form>
